import { subDays } from 'date-fns';

import { date } from '@/utils/filters';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import columns from './columns';

const namespaced = true;

const state = {
  history: [],
  columns,
  currentPage: 0,
  lastRefreshDate: null,
  pageSize: 100,
  searchKeyword: '',
  filters: {},
  dateRange: {
    start: date(subDays(new Date(), 30)),
    end: date(new Date()),
  },
};

export default {
  namespaced,
  actions,
  getters,
  mutations,
  state,
};
